import { styled } from '@mui/material';
import { useTranslation } from '@kc-console/core';

import { Button } from '../Button';

export interface SelectConfirmableButtonsProps {
  onApply: () => void;
  onCancel: () => void;
  applyLabel?: string;
  cancelLabel?: string;
  disabledApply?: boolean;
  disabledCancel?: boolean;
}

export function SelectConfirmableButtons(props: SelectConfirmableButtonsProps) {
  const { t } = useTranslation();
  const {
    applyLabel = t('common:common.action.confirm'),
    cancelLabel = t('common:common.action.cancel'),
    onApply,
    onCancel,
    disabledApply,
    disabledCancel,
  } = props;

  return (
    <Root>
      <Button size="md" variant="tertiary" onClick={onCancel} disabled={disabledCancel}>
        {cancelLabel}
      </Button>
      <Button size="md" variant="primary" onClick={onApply} disabled={disabledApply}>
        {applyLabel}
      </Button>
    </Root>
  );
}

const Root = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;
